import React, { Component } from 'react'
import Parser from 'html-react-parser'
import { PhoneIcon, MenuIcon, EmailIcon, LocationIcon, MapDirectionsIcon } from './SVGIcons';

import OffcanvasForm from './OffcanvasForm';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCallForm: false,
      lightboxOpen: false,  // Состояние для Lightbox
    };
  }

  // Метод для открытия формы заказа звонка
  openCallForm = () => {
    this.setState({ showCallForm: true });
  };

  // Метод для закрытия формы заказа звонка
  closeCallForm = () => {
    this.setState({ showCallForm: false });
  };

  // Открыть Lightbox со схемой проезда
  openSchemaLightbox = () => {
    this.setState({ lightboxOpen: true });
    document.body.style.overflow = 'hidden';
  }

  // Закрыть Lightbox
  closeSchemaLightbox = () => {
    this.setState({ lightboxOpen: false });
    document.body.style.overflow = 'auto';
  }

  // Обработка нажатия клавиш для Lightbox
  handleKeyDown = (e) => {
    if (!this.state.lightboxOpen) return;
    
    if (e.key === 'Escape') {
      this.closeSchemaLightbox();
    }
  }

  // Обработчик успешной отправки
  handleFormSuccess = (message) => {
    // Закрываем Offcanvas меню
    this.props.hide();
    // Показываем сообщение об успехе
    if (this.props.onSuccess) {
      this.props.onSuccess(message);
    }
  };

  // Обработчик ошибки отправки
  handleFormError = (error) => {
    if (this.props.onError) {
      this.props.onError(error);
    }
  };

  componentDidMount() {
    this.setState({
      isClient: true
    });
    // Добавляем обработчик клавиш
    window.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    // Удаляем обработчик клавиш и возвращаем прокрутку
    window.removeEventListener('keydown', this.handleKeyDown);
    document.body.style.overflow = 'auto';
  }

  // Функция для парсинга координат
  parseCoords = (coordsString) => {
    if (!coordsString) return null;
    const [lat, lng] = coordsString.split(',').map(coord => parseFloat(coord.trim()));
    return [lat, lng];
  }

  // Компонент для отображения карты
  renderMap = (coords, height = '125px', mapId = 'footer-map') => {
    const { isClient, mapsError } = this.state;
    
    if (!isClient) {
      return this.renderMapPlaceholder(height);
    }

    if (mapsError) {
      return this.renderMapPlaceholder(height, 'Ошибка загрузки карты');
    }

    if (!coords) {
      return this.renderMapPlaceholder(height, 'Координаты не указаны');
    }

    if (typeof window !== 'undefined' && window.ymaps) {
      return (
        <div 
          id={`map-${mapId}`}
          className='w-full h-full rounded-[15px]'
          style={{ height }}
          ref={(el) => {
            if (el && !el.hasChildNodes()) {
              this.initMap(el, coords);
            }
          }}
        />
      );
    }

    return this.renderMapPlaceholder(height);
  }

  renderMapPlaceholder = (height, message = 'Загрузка карты...') => {
    return (
      <div 
        className='w-full h-full rounded-[15px] bg-[#F5F7F9] flex items-center justify-center'
        style={{ height }}
      >
        <div className='text-[#032432]/60'>{message}</div>
      </div>
    );
  }

  initMap = (container, coords) => {
    if (!window.ymaps) return;

    window.ymaps.ready(() => {
      try {
        const map = new window.ymaps.Map(container, {
          center: coords,
          zoom: 16,
          controls: ['zoomControl']
        });

        // Добавляем метку
        const placemark = new window.ymaps.Placemark(
          coords,
          {
            hintContent: 'Наш адрес',
            balloonContent: '606000, Россия, Нижегородская обл., г. Дзержинск, Восточный промрайон Капролактам'
          },
          {
            preset: 'islands#blueDotIcon'
          }
        );
        map.geoObjects.add(placemark);

      } catch (error) {
        console.error('Error initializing map:', error);
      }
    });
  }

  render() {

    const data = this.props?.data || {}
    const links = data?.links || []
    const { showCallForm, lightboxOpen } = this.state

    // Парсим координаты для карты
    const mapCoords = this.parseCoords(data?.mapcoords);

    return (
      <>
        <div className='mt-[100px] bg-[#141414] rounded-t-[28px] pt-[23px] lg:pt-[40px] pb-[20px]'>
          <div className='container'>
            <div className='w-full flex justify-between items-center'>
              <div className='flex flex-col lg:flex-row w-full lg:w-auto justify-center items-center gap-[10px] lg:gap-[16px]'>
                <a href="/">
                  <img src={data.logo} width={82} height={40} className='h-auto flex-none' />
                </a>
                <div className='hidden lg:block h-[24px] w-px bg-white/25' />
                <div className='text-small text-white leading-none'>
                  {Parser(data?.slogan3 || '')}
                </div>
              </div>
              <div className='hidden lg:flex items-center gap-[22px]'>
                <div className='text-white text-small'>Возникли вопросы?</div>
                <div onClick={() => this.openCallForm()} className='cursor-pointer bg-[#BC0005] duration-300 ease-in-out hover:bg-[#930105] px-[32px] h-[42px] flex-none flex items-center justify-center rounded-[14px] gap-[12px] text-white'>
                  <PhoneIcon />
                  <div className='text-base'>Связаться</div>
                </div>
              </div>
            </div>
            <div className='w-full h-px bg-white/10 mt-[18px]' />
            <div className='flex flex-col lg:flex-row justify-between gap-[20px] lg:gap-[60px] mt-[30px]'>
              <div className='hidden lg:flex flex-col justify-between'>
                <div onClick={() => this.props.showMenu()} className='cursor-pointer bg-white duration-300 ease-in-out hover:bg-[#DBE7F3] px-[22px] h-[42px] flex-none flex items-center justify-center rounded-[14px] gap-[12px] text-[#001553]'>
                  <MenuIcon stroke="#001553" />
                  <div className='text-base'>Меню</div>
                </div>
                
                {/* Измененный блок "На маркетплейсах" для десктопа */}
                <div className='relative group'>
                  <div className='flex items-center gap-[8px] cursor-pointer'>
                    <img src={data?.marketImage} width={42} height={26} className='flex-none h-auto' />
                    <div className='text-base text-white'>На маркетплейсах</div>
                  </div>
                  
                  {/* Невидимый элемент для сохранения hover при движении мышки */}
                  <div className='hidden group-hover:block absolute bottom-full left-0 w-full h-[8px]'></div>
                  
                  {/* Dropdown меню маркетплейсов */}
                  <div className='hidden group-hover:block absolute bottom-full left-0 mb-[8px] bg-white border border-gray-200 rounded-[14px] shadow-lg py-[8px] min-w-[180px] z-50'>
                    <a 
                      href={data?.market} 
                      target='_blank' 
                      className='block px-[16px] py-[8px] text-base text-ptblack hover:text-[#BC0005] hover:bg-gray-100 rounded-[8px] transition-colors whitespace-nowrap'
                    >
                      Ozon
                    </a>
                    <a 
                      href={data?.market2} 
                      target='_blank' 
                      className='block px-[16px] py-[8px] text-base text-ptblack hover:text-[#BC0005] hover:bg-gray-100 rounded-[8px] transition-colors whitespace-nowrap'
                    >
                      Wildberries
                    </a>
                  </div>
                </div>
              </div>
              <div>
                <div className='uppercase text-cardTitle text-white duration-300 ease-in-out hover:bg-[#DBE7F3] font-light leading-none flex items-center gap-[10px]'>
                  <div>Меню</div>
                  <div onClick={() => this.props.showMenu()} className='cursor-pointer bg-white p-[11px] flex-none flex lg:hidden items-center justify-center rounded-[14px] gap-[12px] text-[#001553]'>
                    <MenuIcon stroke="#001553" />
                  </div>
                </div>
                <div className='grid grid-cols-3 lg:grid-cols-2 gap-[12px] mt-[12px]'>
                  {data?.menu.map((item, index) => (
                    <a key={index} className='text-white/60 text-[12px]' href={item.url}>{item.pagetitle}</a>
                  ))}
                </div>
                <div className='w-full h-[174px] max-w-full bg-orange-200 rounded-[14px] mt-[20px] lg:hidden overflow-hidden'>
                  {this.renderMap(mapCoords, '174px', 'footer-map')}
                </div>
                
                {/* Измененная кнопка "Схема проезда" для мобильной версии - открывает Lightbox */}
                <div 
                  onClick={() => this.openSchemaLightbox()} 
                  className='mt-[8px] lg:hidden cursor-pointer bg-[#001553] px-[32px] h-[42px] flex-none flex items-center justify-center rounded-[14px] gap-[12px] text-white'
                >
                  <MapDirectionsIcon />
                  <div className='text-base'>Схема проезда</div>
                </div>
              </div>
              <div className='w-full h-px bg-white/10 lg:hidden' />
              <div className='lg:block grid grid-cols-2 items-start'>
                <div>
                  <div className='flex items-center gap-[9px] text-white uppercase leading-none text-[16px]'>
                    <PhoneIcon width={15} height={15} stroke="white" />
                    <div>Телефоны</div>
                  </div>
                  <div className='grid grid-cols-1 gap-[3px] mt-[12px]'>
                    {data?.phone.map( ( phone, k ) => (
                      <a href={`tel:${phone.replace(/[-()\s]/g, '')}`} key={k} className='text-white/60 text-[12px]'>{phone}</a>
                    ) )}
                  </div>
                </div>
                <div>
                  <div className='flex items-center gap-[9px] text-white uppercase leading-none text-[16px] lg:mt-[20px]'>
                    <EmailIcon />
                    <div>e-mail</div>
                  </div>
                  <div className='grid grid-cols-1 gap-[3px] mt-[12px]'>
                    {data?.email?.length > 0 ? data.email.map((email, index) => (
                      <a key={index} href={`mailto:${email}`} className='text-white/60 text-[12px]'>
                        {email}
                      </a>
                    )) : ''}
                  </div>
                </div>
                <div className='col-span-2'>
                  <div className='flex items-center gap-[9px] text-white uppercase leading-none text-[16px] mt-[20px]'>
                    <LocationIcon />
                    <div>Адрес</div>
                  </div>
                  <div className='grid grid-cols-1 gap-[3px] mt-[12px]'>
                    <a href={data?.adreslink || ''} target='_blank' className='text-white/60 text-[12px]'>
                      {Parser(data?.adres || '')}
                    </a>
                  </div>
                </div>
                <div className='flex lg:hidden flex-col items-start gap-[8px] col-span-2 mt-[20px]'>
                  <div className='text-white text-small'>Возникли вопросы?</div>
                  <a href={`tel:${data?.phone[0].replace(/[-()\s]/g, '')}`} className='cursor-pointer bg-[#BC0005] duration-300 ease-in-out hover:bg-[#930105] px-[32px] h-[42px] flex-none flex items-center justify-center rounded-[14px] gap-[12px] text-white'>
                    <PhoneIcon />
                    <div className='text-base'>Связаться</div>
                  </a>
                </div>
              </div>
              
              {/* Официальные представители */}
              <div className='w-auto max-w-[380px] space-y-[20px]'>
                <div>
                  <div className='text-white uppercase leading-none text-[16px] font-medium mb-[8px]'>
                    Официальный представитель по Республике Беларусь:
                  </div>
                  <div className='text-white/60 text-[12px] leading-relaxed'>
                    <div>ОДО "Ударник"</div>
                    <div>г. Витебск, Республика Беларусь</div>
                    <div>Магазин-склад: г. Витебск, ул. Ак.Павлова 6</div>
                    <a href='tel:+375292900288' className='text-white/60 hover:text-white transition-colors'>+37529-290-02-88</a>
                    <div>
                      E-mail: <a href='mailto:office@vitudarnik.by' className='text-white/60 hover:text-white transition-colors'>office@vitudarnik.by</a>
                    </div>
                    <div>
                      Сайт: <a href='https://company.udarnik.by' target='_blank' rel='noopener noreferrer' className='text-white/60 hover:text-white transition-colors'>company.udarnik.by</a>
                    </div>
                  </div>
                </div>
                <div>
                  <div className='text-white uppercase leading-none text-[16px] font-medium mb-[8px]'>
                    Официальный представитель по Республике Казахстан:
                  </div>
                  <div className='text-white/60 text-[12px] leading-relaxed'>
                    <div>ТОО "BARTOG A.P."</div>
                    <div>Республика Казахстан, г. Алматы, ул. Бекмаханова, д. № 98</div>
                    <div>
                      <a href='tel:+77084792727' className='text-white/60 hover:text-white transition-colors'>+7 708 479 2727</a> Рахим
                    </div>
                  </div>
                </div>
              </div>
              
              <div className='hidden lg:flex flex-col justify-between gap-[20px]'>
                <div className='w-[359px] max-w-full bg-orange-200 rounded-[14px] overflow-hidden'>
                  {this.renderMap(mapCoords, '176px', 'footer-map')}
                </div>
                <div className='flex justify-start items-start'>
                  {/* Измененная кнопка "Схема проезда" для десктопа - открывает Lightbox */}
                  <div 
                    onClick={() => this.openSchemaLightbox()} 
                    className='cursor-pointer bg-[#001553] px-[32px] h-[42px] flex-none flex items-center justify-center rounded-[14px] gap-[12px] text-white'
                  >
                    <MapDirectionsIcon />
                    <div className='text-base'>Схема проезда</div>
                  </div>
                </div>
              </div>
            </div>
            <div className='w-full h-px bg-white/10 mt-[20px]' />
            <div className='w-full flex flex-col lg:flex-row gap-[10px] items-center justify-between mt-[20px]'>
              
              {/* Измененный блок "На маркетплейсах" для мобильной версии */}
              <div className='relative group lg:hidden'>
                <div className='flex items-center gap-[8px] cursor-pointer'>
                  <img src={data?.marketImage} width={42} height={26} className='flex-none h-auto' />
                  <div className='text-base text-white'>На маркетплейсах</div>
                </div>
                
                {/* Невидимый элемент для сохранения hover при движении мышки */}
                <div className='hidden group-hover:block absolute bottom-full left-0 w-full h-[8px]'></div>
                
                {/* Dropdown меню маркетплейсов для мобильной версии */}
                <div className='hidden group-hover:block absolute bottom-full left-0 mb-[8px] bg-white border border-gray-200 rounded-[14px] shadow-lg py-[8px] min-w-[180px] z-50'>
                  <a 
                    href={data?.market} 
                    target='_blank' 
                    className='block px-[16px] py-[8px] text-base text-ptblack hover:text-[#BC0005] hover:bg-gray-100 rounded-[8px] transition-colors whitespace-nowrap'
                  >
                    Ozon
                  </a>
                  <a 
                    href={data?.market2} 
                    target='_blank' 
                    className='block px-[16px] py-[8px] text-base text-ptblack hover:text-[#BC0005] hover:bg-gray-100 rounded-[8px] transition-colors whitespace-nowrap'
                  >
                    Wildberries
                  </a>
                </div>
              </div>
              
              <div className='text-small text-white/60'>© {new Date().getFullYear()} {data?.copy}</div>
              <a className='text-small text-white/60' href={links?.pconf}>Политика конфиденциальности</a>
            </div>
          </div>
        </div>

        {/* Lightbox для схемы проезда */}
        {lightboxOpen && (
          <div 
            className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-90'
            onClick={this.closeSchemaLightbox}
          >
            {/* Кнопка закрытия */}
            <button 
              className='absolute top-5 right-5 text-white text-4xl hover:text-gray-300 z-10 w-[50px] h-[50px] flex items-center justify-center rounded-full bg-black/50 hover:bg-black/70 transition-colors'
              onClick={this.closeSchemaLightbox}
            >
              ×
            </button>

            {/* Изображение схемы проезда */}
            <div 
              className='relative max-w-[90vw] max-h-[90vh] rounded-[15px] overflow-hidden'
              onClick={(e) => e.stopPropagation()}
            >
              <img 
                src={data?.schemagif} 
                alt='Схема проезда'
                className='max-w-full max-h-[90vh] object-contain'
              />
              
              {/* Подпись */}
              <div className='absolute bottom-5 left-1/2 -translate-x-1/2 text-white bg-black bg-opacity-70 px-4 py-2 rounded-full text-sm whitespace-nowrap'>
                Схема проезда
              </div>
            </div>
          </div>
        )}

        {/* Форма заказа звонка */}
        <OffcanvasForm
          show={showCallForm}
          hide={this.closeCallForm}
          formTitle="Связаться"
          formText="Оставьте свои контактные данные, и мы свяжемся с вами в ближайшее время."
          onSuccess={this.handleFormSuccess}
          onError={this.handleFormError}
        />
      </>
    )
  }
}

export default App;